// Icons.js
import React from 'react';

export const PinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M12 0C7.8 0 4 3.2 4 7c0 5.3 7 13 7 13s7-7.7 7-13c0-3.8-3.2-7-7-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
  </svg>
);

export const BedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M20 9V7c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4v8h2v-4h12v4h2v-8h-2zM14 7h4v2h-4V7z"/>
  </svg>
);

export const BathIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M20 12V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v7H1v6h2v2h18v-2h2v-6h-3zm-6-7h4v5h-4V5zM6 5h4v5H6V5zm14 14H4v-4h16v4z"/>
  </svg>
);

export const SizeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
    <path d="M7.5 7.5h4v4h-4zM12 12h4v4h-4zM7.5 12h4v4h-4z"/>
  </svg>
);